import { useState } from 'react';
import type {
  SettingsTab,
  GeneralConfig,
  FirebaseConfig,
  GoogleConfig,
  EmailConfig,
  OpenAIConfig,
  ResendConfig,
  StorageConfig,
  GrafanaConfig,
  BudgetConfig,
  BudgetTestResult,
  TestResults,
  ShowPasswords
} from './types';
import {
  DEFAULT_GENERAL_CONFIG,
  DEFAULT_FIREBASE_CONFIG,
  DEFAULT_GOOGLE_CONFIG,
  DEFAULT_EMAIL_CONFIG,
  DEFAULT_OPENAI_CONFIG,
  DEFAULT_RESEND_CONFIG,
  DEFAULT_STORAGE_CONFIG,
  DEFAULT_GRAFANA_CONFIG,
  DEFAULT_BUDGET_CONFIG
} from './constants';

export function useSettingsState() {
  const [activeTab, setActiveTab] = useState<SettingsTab>('general');
  const [isSaving, setIsSaving] = useState(false);
  const [testResults, setTestResults] = useState<TestResults>({});
  const [showPasswords, setShowPasswords] = useState<ShowPasswords>({});

  const [testingGrafanaConnection, setTestingGrafanaConnection] = useState(false);
  const [grafanaTestResult, setGrafanaTestResult] = useState<string | null>(null);

  const [showBudgetApiKey, setShowBudgetApiKey] = useState(false);
  const [testingBudgetConnection, setTestingBudgetConnection] = useState(false);
  const [budgetTestResult, setBudgetTestResult] = useState<BudgetTestResult | null>(null);
  const [savingBudgetConfig, setSavingBudgetConfig] = useState(false);

  const [generalConfig, setGeneralConfig] = useState<GeneralConfig>(DEFAULT_GENERAL_CONFIG);
  const [firebaseConfig, setFirebaseConfig] = useState<FirebaseConfig>(DEFAULT_FIREBASE_CONFIG);
  const [googleConfig, setGoogleConfig] = useState<GoogleConfig>(DEFAULT_GOOGLE_CONFIG);
  const [emailConfig, setEmailConfig] = useState<EmailConfig>(DEFAULT_EMAIL_CONFIG);
  const [openaiConfig, setOpenaiConfig] = useState<OpenAIConfig>(DEFAULT_OPENAI_CONFIG);
  const [resendConfig, setResendConfig] = useState<ResendConfig>(DEFAULT_RESEND_CONFIG);
  const [storageConfig, setStorageConfig] = useState<StorageConfig>(DEFAULT_STORAGE_CONFIG);
  const [grafanaConfig, setGrafanaConfig] = useState<GrafanaConfig>(DEFAULT_GRAFANA_CONFIG);
  const [budgetConfig, setBudgetConfig] = useState<BudgetConfig>(DEFAULT_BUDGET_CONFIG);

  return {
    configs: {
      generalConfig,
      firebaseConfig,
      googleConfig,
      emailConfig,
      openaiConfig,
      resendConfig,
      storageConfig,
      grafanaConfig,
      budgetConfig
    },
    setters: {
      setGeneralConfig,
      setFirebaseConfig,
      setGoogleConfig,
      setEmailConfig,
      setOpenaiConfig,
      setResendConfig,
      setStorageConfig,
      setGrafanaConfig,
      setBudgetConfig
    },
    ui: {
      activeTab,
      setActiveTab,
      isSaving,
      setIsSaving,
      testResults,
      setTestResults,
      showPasswords,
      setShowPasswords,
      testingGrafanaConnection,
      setTestingGrafanaConnection,
      grafanaTestResult,
      setGrafanaTestResult,
      showBudgetApiKey,
      setShowBudgetApiKey,
      testingBudgetConnection,
      setTestingBudgetConnection,
      budgetTestResult,
      setBudgetTestResult,
      savingBudgetConfig,
      setSavingBudgetConfig
    }
  };
}

export type SettingsState = ReturnType<typeof useSettingsState>;
